import $ from 'jquery';
import {Easings, smoothy} from "../Libraries/smoothy";

function scrollToHash(hash) {
    if (hash === '') {
        return false;
    }
    let $target;
    if (hash === '#' || hash === '#top') {
        $target = $(document.body);
    } else {
        try {
            $target = $(hash);
        } catch (e) {
            console.warn(e);
            return;
        }
    }
    if ($target.length === 0) {
        return false;
    }
    let oldId = $target.attr('id');
    $target.removeAttr('id');
    smoothy(() => $target.offset().top, 1000, Easings.easeOutQuint).then(() => {
        $target.attr('id', oldId);
    });
    return true;
}

if (window.location.hash) {
    scrollToHash(window.location.hash);
}

// links with .no-scroll are ignored.
$('a[href*="#"]:not(.no-scroll):not([class^="js-"]):not([class*=" js-"])').on('click', function (e) {
    if (
        this.protocol === window.location.protocol
        && this.host === window.location.host
        && this.pathname === window.location.pathname
    ) {
        if (scrollToHash(this.hash)) {
            e.preventDefault();
        }
    }
});
